var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnalyticalReporting01 = function SvgAnalyticalReporting01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "analytical_reporting-01_svg2__a",
    x1: 24.81,
    x2: 171.07,
    y1: 168.81,
    y2: 22.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#analytical_reporting-01_svg2__a",
    id: "analytical_reporting-01_svg2__b",
    x1: 39.81,
    x2: 186.07,
    y1: 183.81,
    y2: 37.55
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#analytical_reporting-01_svg2__a",
    id: "analytical_reporting-01_svg2__c",
    x1: 71.48,
    x2: 217.73,
    y1: 215.48,
    y2: 69.22
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#analytical_reporting-01_svg2__a",
    id: "analytical_reporting-01_svg2__d",
    x1: 91.48,
    x2: 237.74,
    y1: 235.48,
    y2: 89.22
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#analytical_reporting-01_svg2__a",
    id: "analytical_reporting-01_svg2__e",
    x1: 3,
    x2: 149.26,
    y1: 147,
    y2: 0.74
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M30.01 143.34h-20c-5.52 0-9.99 4.48-10.01 10v43.33c0 1.84 1.49 3.33 3.33 3.33h33.33c1.84 0 3.33-1.49 3.33-3.33v-43.33c0-5.52-4.48-9.99-10-10H30Zm3.33 49.99H6.68v-39.99c0-1.84 1.49-3.33 3.33-3.33h20c1.84 0 3.33 1.49 3.33 3.33z",
    style: {
      fill: "url(#analytical_reporting-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.33 96.68h-20c-5.52 0-9.99 4.48-10 10v89.99c0 1.84 1.49 3.33 3.33 3.33h33.33c1.84 0 3.33-1.49 3.33-3.33v-89.99c0-5.52-4.48-9.99-10-10Zm3.34 96.65H60.01v-86.65c0-1.84 1.49-3.33 3.33-3.33h20c1.84 0 3.33 1.49 3.33 3.33z",
    style: {
      fill: "url(#analytical_reporting-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.66 116.68h-20c-5.52 0-9.99 4.48-10 10v69.99c0 1.84 1.49 3.33 3.33 3.33h33.33c1.84 0 3.33-1.49 3.33-3.33v-69.99c0-5.52-4.48-9.99-10-10Zm3.33 76.65h-26.66v-66.66c0-1.84 1.49-3.33 3.33-3.33h20c1.84 0 3.33 1.49 3.33 3.33z",
    style: {
      fill: "url(#analytical_reporting-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.99 90.02h-20c-5.52 0-9.99 4.48-10 10v96.65c0 1.84 1.49 3.33 3.33 3.33h33.33c1.84 0 3.33-1.49 3.33-3.33v-96.65c0-5.52-4.48-9.99-10-10Zm3.33 103.31h-26.66v-93.32c0-1.84 1.49-3.33 3.33-3.33h20c1.84 0 3.33 1.49 3.33 3.33z",
    style: {
      fill: "url(#analytical_reporting-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.06 39.94c6.11 6.87 16.11 8.69 24.25 4.41s12.3-13.56 10.09-22.48-10.22-15.19-19.41-15.18a19.987 19.987 0 0 0-18.48 27.62l-19.92 12.45c-3.58-4.06-8.67-6.49-14.08-6.72s-10.68 1.76-14.6 5.5L91.1 29.18c4.61-8.92 1.89-19.88-6.36-25.61S65.27-.88 58.53 6.56C51.78 14 51.6 25.29 58.1 32.94L30.16 66.15c-8.96-5.27-20.46-2.8-26.47 5.69-6 8.49-4.5 20.16 3.45 26.85 7.96 6.69 19.71 6.17 27.05-1.2 7.33-7.37 7.8-19.13 1.07-27.05L63.2 37.23c7.67 4.56 17.45 3.45 23.89-2.73l21.81 16.36c-4.25 8.22-2.29 18.29 4.72 24.32 7.01 6.04 17.26 6.47 24.76 1.05s10.3-15.28 6.76-23.84zm14.93-26.59c7.36 0 13.33 5.97 13.33 13.33S187.35 40 179.99 40.01c-7.36 0-13.33-5.97-13.33-13.33s5.97-13.33 13.33-13.33M20.01 96.68c-7.36 0-13.33-5.97-13.33-13.33s5.97-13.33 13.33-13.33 13.33 5.97 13.33 13.33-5.97 13.32-13.33 13.33m53.33-63.33c-7.36 0-13.33-5.97-13.33-13.33S65.98 6.69 73.34 6.69s13.33 5.97 13.33 13.33-5.97 13.32-13.33 13.33m53.32 40c-7.36 0-13.33-5.97-13.33-13.33s5.97-13.33 13.33-13.33 13.33 5.97 13.33 13.33-5.97 13.32-13.33 13.33",
    style: {
      fill: "url(#analytical_reporting-01_svg2__e)"
    }
  }));
};
export default SvgAnalyticalReporting01;